import { PopoverSize, Select } from 'app/shared/components/generic-ui';
import {
  CellAlignment,
  CellSize,
} from 'app/shared/components/generic-ui/Table/Table.types';
import { useBatchApi } from 'app/shared/hooks';
import { useCallback, useEffect, useState } from 'react';
import { useStyles } from './EntitiesDropdown.styles';
import { CustomTypography } from 'app/shared/components/generic-ui/Typography/Typography';
import { IBatchesCheckbox } from 'types';

interface IEntitiesDropdownProps {
  label: string;
  selectedValues?: string[];
  selectedItems?: IBatchesCheckbox[];
  onChangeSelectedEntities: (
    values: string[],
    items?: IBatchesCheckbox[],
  ) => void;
}

export const EventStatusDropdown = ({
  label,
  selectedItems,
  selectedValues,
  onChangeSelectedEntities,
}: IEntitiesDropdownProps) => {
  const { classes } = useStyles();
  const [searchQuery, setSearchQuery] = useState('');

  const columns = [
    {
      id: 'value',
      label: 'Name',
      alignment: CellAlignment.LEFT,
      size: CellSize.MEDIUM,
    },
  ];

  const {
    historyBatchStatusesResponse,
    fetchHistoryBatchStatuses,
    isFetchingHistoryBatchStatuses,
  } = useBatchApi({});

  const renderCell = useCallback((rowData: any, cellId: string) => {
    return <div style={{ whiteSpace: 'nowrap' }}>{rowData[cellId]}</div>;
  }, []);

  useEffect(() => {
    fetchHistoryBatchStatuses();
  }, [fetchHistoryBatchStatuses]);

  const data = (historyBatchStatusesResponse?.data || []).filter(el =>
    el.key.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const changeSelectedValuesHandler = useCallback(
    (values: string[]) => {
      const currentItems = values.map((idWithPrefix: string) => {
        const prefix = idWithPrefix[0];
        const id = idWithPrefix.slice(1);
        const element = historyBatchStatusesResponse?.data.find(
          el => el.value === id,
        );
        const selectedElement = selectedItems?.find(el => el.id === id);

        return element
          ? {
              id: element?.key || '',
              label: element?.value || '',
              prefix,
            }
          : { id: '', label: '', ...selectedElement, prefix };
      });

      onChangeSelectedEntities(values, currentItems);
    },
    [
      onChangeSelectedEntities,
      historyBatchStatusesResponse?.data,
      selectedItems,
    ],
  );

  return (
    <div className={classes.selectContainer}>
      <CustomTypography variant="caption1" color="greyscale1">
        {label}
      </CustomTypography>

      <Select.Search
        searchQuery={searchQuery}
        isLoading={isFetchingHistoryBatchStatuses}
        valueId={'value'}
        labelId={'key'}
        options={data}
        selectedValues={selectedValues}
        selectedItems={selectedItems}
        onChangeSelectedValues={changeSelectedValuesHandler}
        onSearchHandler={value => {
          setSearchQuery(value);
        }}
        popoverSize={PopoverSize.BIG}
        renderCell={renderCell}
        columns={columns}
        clickHandler={fetchHistoryBatchStatuses}
      />
    </div>
  );
};
